<template>
  <div class="p-4">
    <div class="flex -mx-4">
      <div class="flex-1 px-4">
        {{ offer.issueDate }}
      </div>
      <div class="flex-none px-4 text-right">
        {{ amount }}
      </div>
      <div v-if="$isAdminOrSuperAdmin" class="px-4">
        <OfferEditModalForm :offer-id="offer.uuid" />
      </div>
    </div>
  </div>
</template>

<script>
import OfferEditModalForm from 'Forms/OfferModalForm/Edit.vue';
import Numbro from '@/utils/numbro';

export default {
  components: {
    OfferEditModalForm,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    amount() {
      return Numbro(this.offer.amount || 0).formatCurrency({ mantissa: 2 });
    },
  },
};
</script>
